import React from 'react';
import Select from 'react-select';

function EditableMultiSelectField({ name, value, onChange, editable, options }) {
  if (!editable) {
    return (value ?? []).join(', ');
  }

  const hasValue = value != null && value.length !== 0;

  return (
    <Select
      name={name}
      defaultValue={hasValue ? value.map((v) => ({ value: v, label: v })) : undefined}
      onChange={onChange}
      closeMenuOnSelect={false}
      isMulti={true}
      disabled={!editable}
      options={options}
    />
  );
}

export default EditableMultiSelectField;
